import React, {useEffect} from 'react';
import styled from "styled-components";
import {HelmetProvider, Helmet} from 'react-helmet-async'
import MissionVision from "../../components/about/MissionVision";
import Team from "../../components/about/Team";
import InnerBanner from "../../components/InnerBanner";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {fetchAbout} from "../../api/redux/about";
import SliderAnimation from "../../components/SliderAnimation";
import CorporateSlider from "../../components/about/CorporateSlider";
const MyComponent = () => {

    const dispatch = useDispatch()

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.ABOUT
        dispatch(fetchAbout([api_url]))
    }, [])

    let getPost = useSelector(state => state.about)
    let meta=getPost?.posts?.page_data?.meta;
    let banner=getPost?.posts?.page_data?.banner;
    let overview=getPost?.posts?.page_data?.overview;
    let values=getPost?.posts?.page_data?.values;
    let bod=getPost?.posts?.page_data?.bod;
    let management=getPost?.posts?.page_data?.management;


    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>{`${meta?.meta_title ? meta?.meta_title : 'About | UCC Infrastructure Ltd.'}`}</title>
                <meta name="description"  content={meta?.meta_desc ? meta?.meta_desc :''}/>
                <meta property="og:title" content={`${meta?.og_title ? meta?.og_title : 'About | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:subtitle" content={`${meta?.og_title ? meta?.og_title : 'About | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:description" content={meta?.og_desc ? meta?.og_desc :''}/>
                <meta property="og:url" content={window?.location?.href}/>
                <meta property="og:image" content={banner?.image}/>
                <meta property="og:type" content={"website"}/>
            </Helmet>

            <StyledComponent>
                <InnerBanner img={banner?.image} mimg={banner?.mobile_image} title={banner?.subtitle} text={banner?.title}/>
                <MissionVision data={overview} id={'overview'}/>
                <CorporateSlider id={'corporate-values'} data={values}/>
                <Team id={'directors'} data={bod}/>
                <Team id={'management'} management data={management}/>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`
    

`;

export default MyComponent;
